import api from '../../plugins/api';

const getCreditAppeal = (params) => {
  return api.get('/api/crm/creditPlatform/getCreditAppeal', params);
};

export default getCreditAppeal;
